export default "__VITE_ASSET__CRzscAJR__"